import request from './request'

export function listStockDocument(data) {
  return request.post('/inventory/stock-documents/list', data)
}
export function getStockDocument(id) {
  return request.get('/inventory/stock-documents/' + id)
}
export function saveStockDocument(data) {
  return request.post('/inventory/stock-documents', data)
}
export function updateStockDocument(data) {
  return request.post('/inventory/stock-documents/update', data)
}
export function deleteStockDocument(ids) {
  return request.post('/inventory/stock-documents/delete', ids)
}
export function approveStockDocument(documentId) {
  return request.post('/inventory/stock-documents/approve', { documentId })
}
export function unapproveStockDocument(documentId) {
  return request.post('/inventory/stock-documents/unapprove', { documentId })
}
export function generateIssueFromOrder(orderId, fromWareHouseId) {
  return request.post('/inventory/stock-documents/generate-issue', { orderId, fromWareHouseId })
}
export function generateIssueMulti(orderId) {
  return request.post('/inventory/stock-documents/generate-issue-multi', { orderId })
}
export function previewIssueAllocation(orderId) {
  return request.get('/inventory/stock-documents/preview-issue-allocation', { params: { orderId } })
}
